module.exports = __webpack_public_path__ + "static/media/welcomeCIO_BlockChainbagel.6d9bf329.svg";